import { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import man from '../../assets/images/man.png';
import { notification } from 'antd';
import { State } from 'country-state-city';

import UploadAnimation from '../../components/Upload/Upload';
import {
  handleLogoImage,
  handleBannerUpload,
} from '../../services/handleImage';
import Upload from '../../assets/icons/Upload';
import DownArrow from '../../assets/icons/DownArrow';
import {
  getSchoolArms,
  getSchoolClasses,
  getSchoolSubjects,
  getCountries,
} from '../../services/schoolService';
import woodenchar from '../../assets/images/wooden-chair 1.svg';
import { baseURL } from '../../utils/axios';
import useClickOutside from '../../hooks/useClickOutside';
import { formatArrayToString } from '../../utils/utils';

const TutorAccountSetup = ({ setSuccessfulModal, cancelAccountsetup }) => {
  const newData = JSON.parse(localStorage.getItem('newData'));
  const [step, setStep] = useState(1);
  const [uploading, setUploading] = useState(false);
  const [imgUrl, setImageUrl] = useState('');
  const [bannerUrl, setBannerUrl] = useState('');
  const [selection, setSelection] = useState('image');
  const [selectedBanner] = useState('');
  const [schoolArms, setSchoolArms] = useState([]);
  const [schoolArmValue, setSchoolArmValue] = useState('');
  const [classOfInterestId, setClassOfInterestId] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [subjectsOfInterest, setSubjectsOfinterest] = useState([]);
  const [subjectOfInterestId, setSubjectOfInterestId] = useState([]);

  const [classesOfInterest, setClassesOfinterest] = useState([]);
  const [dropdowns, setDropdowns] = useState({
    classArms: false,
    classOfInterest: false,
    subjectOfInterest: false,
  });
  const [selectedSchoolArms, setSelectedSchoolArms] = useState([]);

  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [updateData, setUpdateData] = useState({
    state: '',
    country: '',
    bio: '',
  });

  const resetDropdown = () => {
    setDropdowns({
      classArms: false,
      classOfInterest: false,
      subjectOfInterest: false,
    });
  };

  //checkbox to handle subject selection
  const handleCheckbox = (e, items) => {
    let updatedCheckList = [...subjectsOfInterest];

    let updatedCheckListId = [...subjectOfInterestId];

    if (e.target.checked) {
      updatedCheckList = [...subjectsOfInterest, e.target.name];
      updatedCheckListId = [...subjectOfInterestId, e.target.id];
    } else {
      updatedCheckList.splice(subjectsOfInterest.indexOf(e.target.name), 1);
      updatedCheckListId.splice(subjectOfInterestId.indexOf(e.target.id), 1);
    }

    setSubjectsOfinterest(updatedCheckList);
    setSubjectOfInterestId(updatedCheckListId);
  };

  //click to select subject
  const handleSelectSubject = (items) => {
    let updatedCheckList = [...subjectsOfInterest];

    let updatedCheckListId = [...subjectOfInterestId];

    if (subjectsOfInterest.includes(items?.name)) {
      updatedCheckList.splice(subjectsOfInterest.indexOf(items?.name), 1);
      updatedCheckListId.splice(subjectOfInterestId.indexOf(items?.id), 1);
    } else {
      updatedCheckList = [...subjectsOfInterest, items?.name];
      updatedCheckListId = [...subjectOfInterestId, items?.id];
    }

    setSubjectsOfinterest(updatedCheckList);
    setSubjectOfInterestId(updatedCheckListId);
  };

  //click to select class
  const handleSelectClass = (items) => {
    let updatedCheckList = [...classesOfInterest];
    let updatedId = [...classOfInterestId];

    if (classesOfInterest.includes(items?.name)) {
      updatedCheckList.splice(classesOfInterest.indexOf(items.name), 1);
      updatedId.splice(classOfInterestId.indexOf(items.id), 1);
    } else {
      updatedCheckList = [...classesOfInterest, items.name];
      updatedId = [...classOfInterestId, items.id];
    }

    setClassesOfinterest(updatedCheckList);
    setClassOfInterestId(updatedId);
  };

  const handleClassCheckbox = (e) => {
    let updatedCheckList = [...classesOfInterest];
    let updatedId = [...classOfInterestId];

    if (e.target.checked) {
      updatedCheckList = [...classesOfInterest, e.target.name];
      updatedId = [...classOfInterestId, e.target.id];
    } else {
      updatedCheckList.splice(classesOfInterest.indexOf(e.target.name), 1);
      updatedId.splice(classOfInterestId.indexOf(e.target.id), 1);
    }

    setClassesOfinterest(updatedCheckList);
    setClassOfInterestId(updatedId);
  };

  //get classes, subjects, school arms
  useEffect(() => {
    const getDetails = async () => {
      let res = await getSchoolArms();
      let resClasses = await getSchoolClasses();
      let resSubjects = await getSchoolSubjects();
      let resCountries = await getCountries();
      setClasses(resClasses.data.classes);
      setSubjects(resSubjects.data.subjects);
      setCountries(resCountries.data.countries);
      if (res.data.schoolArms.length === 0) {
        setSchoolArms([
          {
            id: 1,
            title: 'Junior Secondary School',
          },
          {
            id: 2,
            title: 'Senior Secondary School',
          },
        ]);
      } else {
        setSchoolArms(res.data.schoolArms);
      }
    };

    getDetails();
  }, []);

  const handleChange = (evt) => {
    const value = evt.target.value;
    const name = evt.target.name;
    setUpdateData({
      ...updateData,
      [name]: value,
    });
  };

  const filterInput = (evt) => {
    const value = evt.target.value;

    if (value) {
      setDropdowns({
        ...dropdowns,
        subjectOfInterest: true,
      });
      let filteredCountries = countries.filter((el) =>
        el.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCountries(filteredCountries);
    }
    if (!value) {
      setDropdowns({
        ...dropdowns,
        subjectOfInterest: false,
      });
    }

    setUpdateData({ ...updateData, country: value });
  };

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '100%',
  };

  const focusedStyle = {
    borderColor: '#2196f3',
  };

  const acceptStyle = {
    borderColor: '#00e676',
  };

  const rejectStyle = {
    borderColor: '#ff1744',
  };

  //upload image on drop
  const onDrop = useCallback(async (acceptedFiles) => {
    setUploading(true);
    let { school } = JSON.parse(localStorage.getItem('school'));
    const token = localStorage.getItem('token');
    try {
      let res = await handleLogoImage(acceptedFiles[0], school.id, token);
      notification['success']({
        message: 'Image uploaded successfully \n Please upload a banner next',
      });
      setImageUrl(res.data.logo);
      setUploading(false);
      setSelection('banner');
    } catch (error) {
      setUploading(false);
      if (error.response.data.data.errors.logo[0] === 'validation.max.file') {
        notification['error']({
          message:
            'Image too large, Please upload an image that is not more than 1mb',
        });
        return;
      }
      notification['error']({
        message: 'An error occured',
      });
    }
  }, []);

  //upload banner image on drop
  const onBannerDrop = useCallback(async (acceptedFiles) => {
    setUploading(true);
    let { school } = JSON.parse(localStorage.getItem('school'));
    const token = localStorage.getItem('token');
    try {
      let res = await handleBannerUpload(acceptedFiles[0], school.id, token);
      notification['success']({
        message: 'Banner uploaded successfully',
      });
      setBannerUrl(res.data.banner);
      setUploading(false);
    } catch (error) {
      setUploading(false);
      if (error.response.data.data.errors.banner[0] === 'validation.max.file') {
        notification['error']({
          message:
            'Image too large, Please upload an image that is not more than 1mb',
        });
        return;
      }
      notification['error']({
        message: 'An error occured',
      });
    }
  }, []);

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({ accept: 'image/*', onDrop });

  const {
    getRootProps: getBannerRootProps,
    getInputProps: getBannerInputProps,
  } = useDropzone({
    accept: 'image/*',
    onDrop: onBannerDrop,
  });
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  //update school
  const updateSchool = async () => {
    const token = localStorage.getItem('token');
    let { school } = JSON.parse(localStorage.getItem('school'));
    let id = school.id;

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    let obj = [];

    subjectOfInterestId.forEach((i) =>
      classOfInterestId.forEach((j) =>
        obj.push({
          subject: i,
          class: j,
        })
      )
    );

    let step1Data = {
      schoolArms: selectedSchoolArms,
      subjectClasses: obj,
    };

    try {
      setLoading(true);
      await axios.put(
        `${baseURL}/schools/${id}`,
        step === 1 ? step1Data : updateData,
        {
          headers: headers,
        }
      );
      notification['success']({
        message: 'Details saved successfully',
      });
      if (step === 1) {
        setStep(2);
        setLoading(false);
      } else {
        setSuccessfulModal(true);
        cancelAccountsetup();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      let errorList =
        error.response.data.data.errors[
          Object.keys(error.response.data.data.errors)[0]
        ];
      notification['error']({
        message: errorList[0],
      });
    }
  };

  //get states in selected country
  const getStates = (countryCode) => {
    setStates(State.getStatesOfCountry(countryCode));
  };

  const classArmsRef = useRef(null);
  const classInterestsRef = useRef(null);
  const subjectInterestsRef = useRef(null);

  useClickOutside(classArmsRef, () => {
    setDropdowns({
      ...dropdowns,
      classArms: false,
    });
  });

  useClickOutside(classInterestsRef, () => {
    setDropdowns({
      ...dropdowns,
      classOfInterest: false,
    });
  });

  useClickOutside(subjectInterestsRef, () => {
    setDropdowns({
      ...dropdowns,
      subjectOfInterest: false,
    });
  });

  const outsideClick = () => {
    if (dropdowns.classArms) {
      setDropdowns({
        ...dropdowns,
        classArms: false,
      });
    }
  };

  return (
    <div onClick={outsideClick}>
      <div className='percentage-wrap' style={{ background: '#F5F5F5' }}>
        <p style={{ color: '#161410' }}>
          {step === 1 ? `0` : (step / 3)?.toFixed(1) * 100}% Complete
        </p>
        <div
          className='percentage-wrap__percentage'
          style={{
            height: '18px',
            width: `${step === 1 ? `0` : (step / 3) * 100}%`,
            background: `${step === 1 ? '#F5F5F5' : '#7cd1b8'}`,
          }}
        ></div>
      </div>
      {step === 1 && (
        <div style={{ padding: '40px' }}>
          <div
            className='selected-school-reg__title'
            style={{ marginBottom: 0 }}
          >
            <h2>Setup your account</h2>
          </div>
          <img src={man} alt='' />
          <div className='selected-school-reg__body'>
            <div
              className='selected-school-reg__body__story-3'
              style={{ display: 'flex', alignItems: 'center', padding: '10px' }}
            >
              <p style={{ fontWeight: '300' }}>
                First, tell us what class(es) and subject(s) you want to teach!
              </p>
            </div>
          </div>
          <div style={{ margin: '40px 0' }}>
            <div className='dropdown-wrapper' style={{ marginBottom: '16px' }}>
              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%', marginBottom: 0 }}
                onClick={() => {
                  dropdowns.classArms
                    ? setDropdowns({ ...dropdowns, classArms: false })
                    : setDropdowns({
                        classOfInterest: false,
                        subjectOfInterest: false,
                        classArms: true,
                      });
                }}
              >
                <label htmlFor='lastName'>
                  What school arm do you want to teach?
                </label>

                <input
                  type='text'
                  name='arm'
                  id='arm'
                  placeholder='Select school arm'
                  value={schoolArmValue}
                  disabled
                />
                <div className='eye-icon'>
                  <DownArrow />
                </div>
              </div>

              {dropdowns.classArms && (
                <div className='dropdown-wrapper__dropdown'>
                  {schoolArms.map((el) => (
                    <div
                      key={el.id}
                      className='dropdown-wrapper__dropdown__item'
                      onClick={() => {
                        setSelectedSchoolArms([el.id]);
                        setSchoolArmValue(el.title);
                        resetDropdown();
                      }}
                    >
                      <img src={woodenchar} alt='' />
                      <p>{el.title}</p>
                    </div>
                  ))}
                  <div
                    className='dropdown-wrapper__dropdown__item'
                    onClick={() => {
                      setSelectedSchoolArms([1, 2]);
                      setSchoolArmValue('Junior & Senior Secondary School');
                      resetDropdown();
                    }}
                  >
                    <img src={woodenchar} alt='' />
                    <p>Junior & Senior Secondary School</p>
                  </div>
                </div>
              )}
            </div>

            <div className='dropdown-wrapper' style={{ marginBottom: '16px' }}>
              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%', marginBottom: 0 }}
                onClick={() =>
                  dropdowns.classOfInterest
                    ? setDropdowns({ ...dropdowns, classOfInterest: false })
                    : setDropdowns({
                        classArms: false,
                        subjectOfInterest: false,
                        classOfInterest: true,
                      })
                }
              >
                <label htmlFor='class'>Class of interest</label>

                <input
                  type='text'
                  name='class'
                  id='class'
                  placeholder='Select class'
                  disabled
                  defaultValue={formatArrayToString(classesOfInterest)}
                />
                <div className='eye-icon'>
                  <DownArrow />
                </div>
              </div>

              {dropdowns.classOfInterest && (
                <div className='dropdown-wrapper__dropdown'>
                  {classes.map((el) => (
                    <div
                      key={el.id}
                      className='dropdown-wrapper__dropdown__item'
                      onClick={() => {
                        handleSelectClass(el);
                        setDropdowns({
                          ...dropdowns,
                          classesOfInterest: true,
                        });
                      }}
                    >
                      <input
                        type='checkbox'
                        name={el.name}
                        id={el.id}
                        onChange={handleClassCheckbox}
                        checked={
                          classesOfInterest.includes(el.name) ? true : false
                        }
                      />
                      <img src={woodenchar} alt='' />
                      <p>{el.name}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className='dropdown-wrapper' style={{ marginBottom: '16px' }}>
              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%', marginBottom: 0 }}
                onClick={() =>
                  dropdowns.subjectOfInterest
                    ? setDropdowns({ ...dropdowns, subjectOfInterest: false })
                    : setDropdowns({
                        classArms: false,
                        classOfInterest: false,
                        subjectOfInterest: true,
                      })
                }
              >
                <label htmlFor='subject'>Subject of interest</label>

                <input
                  type='text'
                  name='subject'
                  id='subject'
                  disabled
                  placeholder='Select subject'
                  defaultValue={formatArrayToString(subjectsOfInterest)}
                />
                <div className='eye-icon'>
                  <DownArrow />
                </div>
              </div>

              {dropdowns.subjectOfInterest && (
                <div className='dropdown-wrapper__dropdown'>
                  {subjects.map((el) => (
                    <div
                      key={el.id}
                      className='dropdown-wrapper__dropdown__item'
                      onClick={() => {
                        handleSelectSubject(el);
                      }}
                    >
                      <input
                        type='checkbox'
                        name={el.name}
                        id={el.id}
                        onChange={handleCheckbox}
                        checked={
                          subjectsOfInterest.includes(el.name) ? true : false
                        }
                      />
                      <p>{el.name}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {step === 2 && (
        <>
          <div style={{ padding: '40px' }}>
            <div
              className='selected-school-reg__title'
              style={{ marginBottom: 0 }}
            >
              <h2>Awesome!</h2>
            </div>
            <img src={man} alt='' />
            <div className='selected-school-reg__body'>
              <div
                className='selected-school-reg__body__story-3'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px',
                }}
              >
                <p style={{ fontWeight: '300' }}>
                  Now, let’s upload your image and banner. Adding an image to
                  your profile will help learners see the contents you offer
                  easily.
                </p>
              </div>
            </div>
          </div>
          <div style={{ margin: '40px 0' }}>
            <div
              className='tutor-banner-select'
              style={{
                backgroundImage: `url(${bannerUrl})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              }}
            >
              {/* {selectedBanner ? (
                <img src={selectedBanner} />
              ) : bannerUrl ? (
                <img src={bannerUrl} />
              ) : (
                <div></div>
              )} */}
            </div>
            <div className='tutor-image-placeholder'>
              {imgUrl ? (
                <img src={imgUrl} alt='' />
              ) : (
                <svg
                  width='60'
                  height='60'
                  viewBox='0 0 60 60'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M30 14.75C32.9 14.75 35.25 17.1 35.25 20C35.25 22.9 32.9 25.25 30 25.25C27.1 25.25 24.75 22.9 24.75 20C24.75 17.1 27.1 14.75 30 14.75ZM30 37.25C37.425 37.25 45.25 40.9 45.25 42.5V45.25H14.75V42.5C14.75 40.9 22.575 37.25 30 37.25ZM30 10C24.475 10 20 14.475 20 20C20 25.525 24.475 30 30 30C35.525 30 40 25.525 40 20C40 14.475 35.525 10 30 10ZM30 32.5C23.325 32.5 10 35.85 10 42.5V50H50V42.5C50 35.85 36.675 32.5 30 32.5Z'
                    fill='#5A5955'
                  />
                </svg>
              )}
            </div>

            <div className='img-selection-area' style={{ height: '300px' }}>
              <div className='tutor-selection'>
                <p
                  onClick={() => setSelection('image')}
                  className={
                    selection === 'image'
                      ? 'tutor-selection__selected-item'
                      : 'tutor-selection__item'
                  }
                >
                  Image
                </p>
                <p
                  onClick={() => setSelection('banner')}
                  className={
                    selection === 'banner'
                      ? 'tutor-selection__selected-item'
                      : 'tutor-selection__item'
                  }
                >
                  Banner
                </p>
              </div>
              {selection === 'image' && (
                <div>
                  {uploading ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                      }}
                    >
                      <UploadAnimation />

                      <p
                        style={{
                          color: '#F71E1E',
                          borderBottom: '2px solid #F71E1E',
                          cursor: 'pointer',
                          textAlign: 'center',
                        }}
                        onClick={() => setUploading(false)}
                      >
                        Cancel
                      </p>
                    </div>
                  ) : (
                    <div className='container'>
                      <div {...getRootProps({ style })}>
                        <input {...getInputProps()} />
                        <Upload />
                        <p>Drag and drop image or </p>
                        <p className='sec-text'> Upload from your computer</p>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {selection === 'banner' && (
                <div>
                  {uploading ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                      }}
                    >
                      <UploadAnimation />

                      <p
                        style={{
                          color: '#F71E1E',
                          borderBottom: '2px solid #F71E1E',
                          cursor: 'pointer',
                          textAlign: 'center',
                        }}
                        onClick={() => setUploading(false)}
                      >
                        Cancel
                      </p>
                    </div>
                  ) : (
                    <div className='container'>
                      <div {...getBannerRootProps({ style })}>
                        <input {...getBannerInputProps()} />
                        <Upload />
                        <p>Drag and drop image or </p>
                        <p className='sec-text'> Upload from your computer</p>
                      </div>
                    </div>
                  )}
                </div>
                // <div className='flex-to-column'>
                //   <div onClick={() => setSelectedBanner(banner1)}>
                //     <img src={banner1} alt='' />
                //   </div>
                //   <div onClick={() => setSelectedBanner(banner2)}>
                //     <img src={banner2} alt='' />
                //   </div>
                //   <div onClick={() => setSelectedBanner(banner3)}>
                //     <img src={banner3} alt='' />
                //   </div>
                //   <div onClick={() => setSelectedBanner(banner4)}>
                //     <img src={banner4} alt='' />
                //   </div>
                //   <div onClick={() => setSelectedBanner(banner5)}>
                //     <img src={banner5} alt='' />
                //   </div>
                // </div>
              )}
            </div>
          </div>
        </>
      )}

      {step === 3 && (
        <div style={{ padding: '40px' }}>
          {' '}
          <div className='selected-school-reg__title'>
            <h2>Awesome!</h2>
          </div>
          <div
            className='selected-school-reg__body'
            style={{ marginTop: '60px' }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                position: 'absolute',
              }}
            >
              <div className='selected-school-reg__body__name-bar'>
                <div className='selected-school-reg__body__name-bar__image'>
                  <img
                    src={imgUrl}
                    alt=''
                    className='selected-school-reg__body__name-bar__image__imgg'
                  />
                </div>
                <p style={{ color: '#fff' }}>
                  {newData?.firstName || ''} {newData?.lastName || ''}
                </p>
              </div>
              {/* <img src={man} alt="" /> */}
            </div>
            <div className='selected-school-reg__body__story-4'>
              <p>
                Now, share with learners a brief but spectacular information
                about you and where you would be teaching from...
              </p>
            </div>
            <div
              className='auth-wrapper__right__form__inputwrapper'
              style={{ width: '100%', marginTop: '40px' }}
            >
              <label htmlFor='bio'>Your bio</label>

              <textarea
                maxlength='200'
                name='bio'
                id='bio'
                value={updateData.bio}
                onChange={handleChange}
                placeholder='Example: Adeyinka is an academic powerhouse, a 10 times award recognition as the best teacher in my 4years as an educator.  Innovation is central to who we are and what we do, and I am keen on inspiring students to be more and do more.'
              />
            </div>
            <div>
              <p
                style={{
                  textAlign: 'right',
                  fontSize: '12px',
                  fontWeight: 300,
                }}
              >
                {200 - updateData.bio.length} characters
              </p>
            </div>

            <div
              className='auth-wrapper__right__form__inputwrapper'
              style={{ width: '100%', marginTop: '16px' }}
            >
              <label htmlFor='lastName'>Where is your current location?</label>
              <p
                style={{
                  fontSize: '12px',
                  fontWeight: 300,
                }}
              >
                Your location will be used to set your currency when creating a
                course
              </p>{' '}
              <div
                className='dropdown-wrapper'
                style={{ marginBottom: '16px', width: '100%' }}
              >
                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%', marginBottom: 0 }}
                  // onClick={() =>
                  //   setDropdowns({
                  //     ...dropdowns,
                  //     subjectOfInterest: !dropdowns.subjectOfInterest,
                  //   })
                  // }
                >
                  <input
                    type='text'
                    name='country'
                    id='country'
                    placeholder='Select country'
                    value={updateData.country}
                    onChange={filterInput}
                    // disabled
                  />
                </div>

                {dropdowns.subjectOfInterest && (
                  <div className='dropdown-wrapper__dropdown'>
                    {filteredCountries?.map((el) => (
                      <div
                        key={el.id}
                        className='dropdown-wrapper__dropdown__item'
                        onClick={() => {
                          setUpdateData({
                            ...updateData,
                            country: el.name,
                          });
                          resetDropdown();
                          getStates(el.isoCode);
                        }}
                      >
                        <p>{el.name}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div
                className='dropdown-wrapper'
                style={{ marginBottom: '16px', width: '100%' }}
              >
                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%', marginBottom: 0 }}
                  onClick={() =>
                    dropdowns.classArms
                      ? setDropdowns({
                          ...dropdowns,
                          classArms: false,
                        })
                      : setDropdowns({
                          ...dropdowns,
                          classArms: true,
                        })
                  }
                >
                  <input
                    type='text'
                    name='state'
                    id='state'
                    placeholder='Your State'
                    defaultValue={updateData.state}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        state: e.target.value,
                      })
                    }
                  />
                  {/* <div className='country-arrow-icon'>
                        <DownArrow />
                      </div> */}
                </div>

                {dropdowns.classArms && (
                  <div className='dropdown-wrapper__dropdown'>
                    {states.map((el) => (
                      <div
                        key={el.id}
                        className='dropdown-wrapper__dropdown__item'
                        onClick={() => {
                          setUpdateData({ ...updateData, state: el.name });
                          resetDropdown();
                        }}
                      >
                        <p>{el.name}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div style={{ borderTop: '1px solid #eeeeee' }}></div>
      <div className='onboarding-modal-footer'>
        <div
          className={
            step === 1
              ? 'onboarding-modal-footer__arrow-1 v-hidden'
              : 'onboarding-modal-footer__arrow-1'
          }
          onClick={() => {
            setStep(step - 1);
          }}
        >
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
              fill='#161410'
            />
          </svg>
          <p>Back</p>
        </div>
        <div className='onboarding-modal-footer__step-dots'>
          {Array(3)
            .fill(3)
            .map((_, index) => (
              <div
                className={
                  step === index + 1
                    ? 'onboarding-modal-footer__step-dots__active-step'
                    : step > index + 1
                    ? 'onboarding-modal-footer__step-dots__filled-step'
                    : 'onboarding-modal-footer__step-dots__inactive-step'
                }
                key={index}
              ></div>
            ))}
        </div>

        <div>
          {step === 3 ? (
            <button
              className='primary-btn'
              disabled={
                loading || updateData.bio === '' || updateData.country === ''
              }
              style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
              onClick={() => {
                updateSchool();
                localStorage.setItem('banner', selectedBanner);
                localStorage.setItem('schoolLogo', imgUrl);
              }}
            >
              {loading ? 'Please wait...' : 'Finish'}
            </button>
          ) : step === 2 ? (
            <button
              className='primary-btn'
              style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
              onClick={() => setStep(step + 1)}
              disabled={!imgUrl}
            >
              {loading ? 'Please wait' : 'Next'}
              <svg
                width='18'
                height='12'
                viewBox='0 0 18 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M0 7L14.17 7L10.59 10.59L12 12L18 6L12 0L10.59 1.41L14.17 5L0 5V7Z'
                  fill='#161410'
                />
              </svg>
            </button>
          ) : (
            <button
              className='primary-btn'
              style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
              onClick={() => (step === 2 ? setStep(step + 1) : updateSchool())}
              disabled={
                selectedSchoolArms.length === 0 ||
                subjectOfInterestId.length === 0 ||
                classOfInterestId.length === 0
              }
            >
              {loading ? 'Please wait' : 'Next'}
              <svg
                width='18'
                height='12'
                viewBox='0 0 18 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M0 7L14.17 7L10.59 10.59L12 12L18 6L12 0L10.59 1.41L14.17 5L0 5V7Z'
                  fill='#161410'
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TutorAccountSetup;
